<template lang="pug">
div(v-show='modalShow')
  .modal__close(@click='closeModal()')
  .modal__overlay(@click='closeModal()')
  .modal__wrapper
    .modal__form.modal__form--downloadTrial
      div
        .form__item
          h1 Your download should begin shortly. Feel free to check any of our other products.

        .form__item
          .form__item--title
            img.image.inline(srcset='https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/mac/icons/cinemagraph-pro-icon.png 1x')
            a(@click='goToLink("/products/mac/cinemagraph-pro/")')
              h2 Cinemagraph Pro for macOS
        .form__item
          .form__item--title
            img.image.inline(srcset='https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/ios/icons/cinemagraph-pro-ios-icon.png 1x')
            a(@click='goToLink("/products/ios/cinemagraph-pro/")')
              h2 Cinemagraph Pro for iOS
        .form__item
          .form__item--title
            img.image.inline(srcset='https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/persecond/icons/persecond-icon.png 1x')
            a(@click='goToLink("/products/mac/persecond/")')
              h2 Persecond for macOS
        .form__item
          .form__item--title
            img.image.inline(srcset='https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@2x.png 2x, https://cdn.flixel.com/static/static-web/products/blendeo/BlendeoAppIcon@1x.png 1x')
            a(@click='goToLink("/products/ios/blendeo/")')
              h2 Blendeo for iOS

  .loading--full(v-if='loading')
  .loading__cover(v-if='loading')
</template>

<script>
import EventBus from '../eventBus.js';

export default {
  name: 'download-trial-modal',
  data() {
    return {
      modalShow: false,
      loading: false,
    };
  },
  mounted() {
    EventBus.$on('showModal', this.showModal);
  },
  methods: {
    goToLink(link) {
      this.$router.push(link);
      this.modalShow = false;
    },
    showModal() {
      this.modalShow = true;
    },
    closeModal() {
      this.modalShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/downloadTrial.vue